import random from 'toxilibs/random.js'

function common (q, symbol, input, output) {
    q.addText(symbol + '(' + input + ') = ANSWER_HERE')
    q.answer = output
}


const questions = {

    doubleSymbols: {
        generator: function (q) {

            const iconsChoice = ['i_bike', 'i_bus', 'i_boat', 'i_car', 'i_plane']

            q.smartChoose([
                {1: {count: 1}},
                {1: {count: 1}},
                {1: {count: 2}},
                {
                    all: {
                        count: [1, 2]
                    }
                }
            ], function (choices) {
                let value = []
                for (let i = 0; i < choices.count; i++) {
                    value.push(random.fairChoice(iconsChoice, {name: 'icon'}))
                }
                value = value.join(' ')

                common(q, 'i_flash', '<span class="inside_parenthesis">' + value + '</span>', value + ' ' + value)
                addBadChoices(choices.count)

            })

            function badChoice (charsCount) {
                let value = []
                for (let i = 0; i < charsCount; i++) {
                    value.push(random.pick(iconsChoice))
                }
                return value.join(' ')
            }

            function addBadChoices (count) {
                if (count === 1) {
                    q.addBadChoices(() => badChoice(random.intBetween(1, 2)))
                } else {
                    let choices = [1, 2, 2, 3, 3, 4, 4].map(charsCount => badChoice(charsCount))
                    q.addBadChoices(choices)
                }

            }

            q.dontQuoteAnswer = true
            q.pointToHelpMe = true
            q.makeItEasy    = true
        },
        errorExpected: true,
        dontGoBack: true
    },

    plusOne: {
        generator: function (q) {
            let tens = random.fairChoiceInt(2, 6, {name: 'tens'})
            let unit = random.fairChoiceInt(1, 8, {name: 'unit'})

            let value = tens * 10 + unit
            common(q, 'i_pawn', value, value + 1)
            q.addBadChoices(() => random.intBetween(10, 40))

            q.pointToHelpMe = true
        },
        errorExpected: true,
        dontGoBack: true
    },

    minusTwo: {
        generator: function (q) {
            let value = random.fairChoiceInt(5, 60)
            common(q, 'i_pine', value, value - 2)
            q.addBadChoices(value + 1, value + 2, () => random.intBetween(5, 60))
        },
        errorExpected: true,
        dontGoBack: true
    },

    timesTwo: {
        generator: function (q) {
            let value = random.fairChoice([3, 4, 5, 6, 7, 8, 10, 11, 20, 22, 30, 40, 50, 100, 200, 300])
            common(q, 'i_moon', value, value * 2)
            q.addBadChoices(value, value * 3, () => random.intBetween(10, value * 3))
        },
        errorExpected: true,
        dontGoBack: true
    },

    plusTen: {
        generator: function (q) {
            let value = random.fairChoiceInt(1, 200)
            common(q, 'i_snow', value, value + 10)
            q.addBadChoices(() => random.intBetween(1, value + 20))
        },
        errorExpected: true,
        dontGoBack: true
    },

    timesTen: {
        generator: function (q) {
            let value = random.fairChoiceInt(1, 200)
            common(q, 'i_eye', value, value * 10)
            q.addBadChoices(() => random.intBetween(1, value) * random.pick(1, 2, 5, 10, 20))
        },
        errorExpected: true,
        dontGoBack: true
    },

    lastDigit: {
        generator: function (q) {
            let value = random.intBetween(10, 999) * 10 + random.fairChoiceInt(0, 9)
            common(q, 'i_rocket', value, value % 10)
            q.addBadChoices(() => random.intBetween(1, value), () => random.intBetween(11, 99), 'digit')
        },
        errorExpected: true,
        dontGoBack: true
    },


    firstDigit: {
        generator: function (q) {
            let digit = random.fairChoiceInt(1, 9)
            let value = digit + String(random.intBetween(10, 999))
            common(q, 'i_bug', value, digit)
            q.addBadChoices(() => random.intBetween(1, 99), 'digit')
        },
        errorExpected: true,
        dontGoBack: true
    }

}

export default questions

